import {gql} from '@apollo/client';
import React from 'react';

import {useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {RequestSchemaSubdependencyInputQuery} from './__generated/RequestSchemaSubdependencyInputQuery';
import BaseSchemaSubdependencyInput from './BaseSchemaSubdependencyInput';
import {ChildDependencyTypes} from './ChildDependencyTypes';

export const REQUEST_SCHEMA_SUBDEPENDENCY_INPUT_QUERY = gql`
  query RequestSchemaSubdependencyInputQuery @skipAudit @engComponent(name: BENCHLING_APPS) {
    requestSchemas {
      ... on RequestSchemaNode {
        ...RequestSchemaGraphQL
      }
    }
  }
  ${getFragmentWrapper('RequestSchema').fragment}
`;

export default function RequestSchemaSubdependencyInput({
  subdependencies,
  onChange,
  dependencyValidation,
  updateDependencyConfigValidation,
  disabled,
  parentDependencySelectedId,
}: ChildDependencyTypes): JSX.Element | null {
  const result = useSkippableBenchlingQuery<RequestSchemaSubdependencyInputQuery>(
    REQUEST_SCHEMA_SUBDEPENDENCY_INPUT_QUERY,
    {
      skip: parentDependencySelectedId == null,
    }
  );

  return (
    <BaseSchemaSubdependencyInput<RequestSchemaSubdependencyInputQuery>
      subdependencies={subdependencies}
      onChange={onChange}
      dependencyValidation={dependencyValidation}
      updateDependencyConfigValidation={updateDependencyConfigValidation}
      disabled={disabled}
      result={result}
      getSchemaFromResult={(result) => {
        const allRequestSchemas = result.data.requestSchemas;
        const requestSchema = allRequestSchemas.find((schema) => schema.id === parentDependencySelectedId);
        return requestSchema ?? null;
      }}
    />
  );
}
